<template>
  <div class="vonage-capture" ref="videos">
    <div class="video" ref="video"></div>
    <div class="devices" v-if="!publisher">
      <VonageListDevice
        :devices="audioDevices"
        v-model="audioDevice"
        label="Select audio device"
      />
      <VonageListDevice
        :devices="videoDevices"
        v-model="videoDevice"
        label="Select video device"
      />
      <button
        :disabled="!videoDevice && !audioDevice"
        @click="publish(videoDevice, audioDevice)"
      >
        Start Broadcast
      </button>
    </div>
    <button v-if="publisher" class="switch" @click="publisher.cycleVideo()">
      switch video
    </button>
  </div>
</template>
<script>
import { OT, sleep, debug } from "/vodalys/vonage/vonage_client_libs";
import VonageListDevice from "./VonageListDevices.vue";

export default {
  components: {
    VonageListDevice,
  },
  data: function () {
    return {
      session: undefined,
      publisher: undefined,
      devices: [],
      videoDevice: undefined,
      audioDevice: undefined,
      publishDescriptor: undefined,
      streamUid: undefined,
    };
  },
  computed: {
    audioDevices() {
      return this.devices.filter((d) => d.kind === "audioInput");
    },
    videoDevices() {
      return this.devices.filter((d) => d.kind === "videoInput");
    },
  },
  props: ["component", "instance", "handler"],
  created() {
  },
  mounted() {
    this.log = debug(`Vonage:Capture:${this._uid}`);

    let { publish_descriptor: publishDescriptor, stream_uid: streamUid } =
      this.instance["vonage_capture:api"].component;

    this.streamUid = streamUid;
    this.publishDescriptor = publishDescriptor;

    OT().then(async (OT) => {
      await OT.getUserMedia({
        video: true,
        audio: true,
      });
      OT.getDevices((error, devices) => {
        if (error) {
          this.error = "Unable to list audio/video devices";
          return;
        }

        this.devices = devices;
        queueMicrotask((_) => {
          let videoDevice = sessionStorage.getItem(`vonageCapture-videoDevice`);
          this.videoDevice = videoDevice || undefined;

          let audioDevice = sessionStorage.getItem(`vonageCapture-audioDevice`);
          this.audioDevice = audioDevice || undefined;
        });
      });
    });

    // this.play(publishDescriptor, streamUid);
  },
  methods: {
    async publish(videoDevice, audioDevice) {
      sessionStorage.setItem(`vonageCapture-videoDevice`, videoDevice);
      sessionStorage.setItem(`vonageCapture-audioDevice`, audioDevice);

      // await sleep(2000)
      this.log("push", {
        publishDescriptor: this.publishDescriptor,
        streamId: this.streamId,
      });

      const { initPublisher, initSession } = await OT();

      let res = await (await fetch(this.publishDescriptor)).json();

      this.log("push", res);

      let { api_key, access_token, session_id, stream_id } = res;

      function handleError(error) {
        if (error) {
          if (error.code == 1500) {
            console.error("unable to publish", error);
            this.session.disconnect();
            this.log("disconected");
            this.session.connect(access_token, (err) => {
              if (err) {
                errorHandler(err);
              }
              this.log("session re-connectd");
            });
          }
        }
      }

      this.session = initSession(api_key, session_id);
      this.session.on("sessionConnected", () => {
        this.log("sessionConected");
        this.session.publish(this.publisher, handleError);
      });

      // Create a publisher
      this.publisher = initPublisher(
        {
          name: stream_id,
          videoSource: videoDevice,
          audioSource: audioDevice,
          //   session: this.session,
          // insertMode: "append",
          resolution: "1280x720",
          insertDefaultUI: false,
          // width: "100%",
          // height: "100%",
          //   element: this.$refs.video,
        },
        handleError
      );

      this.publisher.on("videoElementCreated", (event) => {
        this.log("videoElementCreated", event);
        this.$refs.video.append(event.element);
      });

      this.log("session init");
      if (this.session.currentState != "connected") {
        this.session.connect(access_token, (err) => {
          if (err) {
            errorHandler(err);
          }
          this.log("session created and connectd");
        });
      } else {
        this.log("session already connected");
        this.session.publish(this.publisher, handleError);
      }
    },
  },
};
</script>

<style lang="scss">
.vonage-capture {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 100;

  background-color: lightgray;
  display: flex;
  align-items: center;
  justify-content: center;

  .devices {
    display: flex;
    align-items: initial;
    flex-direction: column;
    gap: 10px;
    z-index: 100;

    * {
      width: 100%;
    }
  }

  .video {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: black;
    width: 100%;
    height: 100%;
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: scale(-1, 1);
    }
  }

  button.switch {
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 100;
  }
}
</style>